
import React from 'react';
import Layout from '@/components/Layout/Layout';
import CalculatorCategory from '@/components/SpecialCalculators/CalculatorCategory';
import SuggestionBox from '@/components/SpecialCalculators/SuggestionBox';
import { calculatorCategories } from '@/data/calculatorCategories';

const SpecialCalculators = () => {
  return (
    <Layout>
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold mb-6">Specialized Calculators</h1>
        <p className="text-gray-600 mb-8">
          These specialized calculators are designed for specific purposes to help you with common calculations beyond basic math.
        </p>
        
        {/* Display calculators by category */}
        {calculatorCategories.map((category, categoryIndex) => (
          <CalculatorCategory 
            key={categoryIndex}
            title={category.title}
            description={category.description}
            calculators={category.calculators}
          />
        ))}

        <SuggestionBox />
      </div>
    </Layout>
  );
};

export default SpecialCalculators;
